var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C10.9934 30 7.22654 28.4397 4.39336 25.6066C1.56029 22.7735 0 19.0066 0 15C0 10.9934 1.56029 7.22654 4.39336 4.39336C7.22654 1.56029 10.9934 0 15 0C19.0066 0 22.7735 1.56029 25.6066 4.39336C28.4397 7.22654 30 10.9934 30 15C30 19.0066 28.4397 22.7735 25.6066 25.6066C22.7735 28.4397 19.0066 30 15 30Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.51562C8.66748 3.51562 3.51562 8.66748 3.51562 15C3.51562 21.3325 8.66748 26.4844 15 26.4844C21.3325 26.4844 26.4844 21.3325 26.4844 15C26.4844 8.66748 21.3325 3.51562 15 3.51562ZM18.7864 18.0363C18.641 18.9016 18.2056 19.7044 17.5607 20.297C17.0599 20.7571 16.4648 21.0666 15.8096 21.2135V22.0312C15.8096 22.5166 15.4161 22.9102 14.9307 22.9102C14.4453 22.9102 14.0518 22.5166 14.0518 22.0312V21.2916C13.2074 21.2331 12.5323 21.0276 11.5586 20.3905C11.1523 20.1247 11.0385 19.58 11.3042 19.1738C11.57 18.7675 12.1147 18.6537 12.5209 18.9195C13.134 19.3206 13.5073 19.4746 14.0518 19.5286V15.0643C13.3826 14.7625 12.8896 14.4748 12.4891 14.1607C11.6925 13.5359 11.3295 12.4483 11.5417 11.3224C11.7737 10.0911 12.6294 9.11197 13.775 8.76691C13.8687 8.73867 13.9607 8.71447 14.0518 8.69203V7.96875C14.0518 7.48336 14.4453 7.08984 14.9307 7.08984C15.4161 7.08984 15.8096 7.48336 15.8096 7.96875V8.59014C16.8057 8.73527 17.506 9.2165 17.8386 9.59818C18.1576 9.9641 18.1195 10.5193 17.7536 10.8382C17.3889 11.1562 16.8361 11.1193 16.5167 10.7567C16.5002 10.7398 16.267 10.5094 15.8096 10.3846V13.8849C16.016 13.9622 16.2224 14.0368 16.4246 14.1083C17.3182 14.4242 18.0089 14.9898 18.422 15.744C18.7919 16.4196 18.9213 17.2336 18.7864 18.0363ZM14.0518 10.5435V13.0949C13.8748 12.9923 13.713 12.8867 13.5739 12.7776C13.3 12.5627 13.1803 12.1193 13.2691 11.6479C13.3438 11.2515 13.5879 10.7825 14.0518 10.5435ZM17.0529 17.7449C16.946 18.3812 16.5238 19.0547 15.8096 19.3706V15.7553C15.8194 15.7588 15.8289 15.7622 15.8387 15.7657C17.1936 16.2445 17.1106 17.4016 17.0529 17.7449Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 15,
    y1: 30,
    x2: 15,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 15,
    y1: 26.4844,
    x2: 15,
    y2: 3.51562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.4f3ebbd198e68162f40d4aa7991ea883.svg";
export { ForwardRef as ReactComponent };